import { PaginationModel } from "../../../models/pagination.model";
import * as AssignmentsActions from "./assignments.actions";
import { AssignmentModel } from "../../../models/assignment.model";
import { AssignmentCategoryModel } from "../../../models/assignmentCategory.model";
import { GuardModel } from "../../../models/guard.model";
import { PriceModel } from "../../../models/price.model";
import { ShiftModel } from '../../../models/shift.model';
import { ReportModel } from '../../../models/report.model';
import { AssignmentStatisticsModel } from '../../../models/assignment.statistics.model';
import { ReportStatistic } from '../../../models/reportStatistic';
import { PreviousAssignmentResponse } from "src/app/models/previous-assignment.model";
import { AssignmentMonthModel } from '../../../models/assignment.model'
import { JobPlaceModel } from "src/app/models/jobPlace.model";
export interface State {
    assignment: AssignmentModel;
    assignmentStatistics: AssignmentStatisticsModel;
    reports: ReportModel[];
    reportStatistics: ReportStatistic;
    selectedReport: ReportModel;
    selectedShift: ShiftModel;
    price: PriceModel;
    categories: AssignmentCategoryModel[];
    assignments: AssignmentModel[];
    assignmentsLoading: boolean;
    pagination: PaginationModel;
    guards: GuardModel[];
    guardsPagination: PaginationModel;
    guardsMeta: {
        page: number,
        perPage: number,
        isLastPage: boolean
    };
    loading: boolean;
    step: number;
    isAssignmentCreatingFromHistory: boolean;
    favouriteGuards: GuardModel[];
    favouritesMeta: {
        page: number,
        perPage: number,
        isLastPage: boolean
    };
    favouritesPagination: PaginationModel
    favouriteGuardsToAdd: GuardModel[];
    guardsToAddMeta: {
        page: number,
        perPage: number,
        isLastPage: boolean
    };
    guardsToAddPagination: PaginationModel
    previousAssignments: PreviousAssignmentResponse;
    assignmnetMonth: AssignmentMonthModel
    jobdefualt: JobPlaceModel[]
}

const initialState: State = {
    assignment: null,
    assignmentStatistics: null,
    selectedShift: null,
    price: null,
    categories: [],
    reports: [],
    reportStatistics: null,
    selectedReport: null,
    assignments: [],
    assignmentsLoading: false,
    pagination: null,
    guards: [],
    guardsPagination: null,
    guardsMeta: {
        page: 0,
        perPage: 20,
        isLastPage: true
    },
    step: 1,
    isAssignmentCreatingFromHistory: false,
    loading: false,
    favouriteGuards: [],
    favouritesMeta: {
        page: 0,
        perPage: 15,
        isLastPage: true
    },
    favouritesPagination: null,
    favouriteGuardsToAdd: [],
    guardsToAddMeta: {
        page: 0,
        perPage: 10,
        isLastPage: true
    },
    guardsToAddPagination: null,
    previousAssignments: null,
    assignmnetMonth: null,
    jobdefualt: []
}

export function assignmentsReducer(state = initialState, action: AssignmentsActions.AssignmentsActions): State {
    switch (action.type) {
        case AssignmentsActions.LOAD_REPORTS_STATISTICS_SUCCESS:
            return {
                ...state,
                reportStatistics: action.payload.data,
            };
        case AssignmentsActions.CREATE_ASSIGNMENT_FROM_HISTORY:
            return {
                ...state,
                isAssignmentCreatingFromHistory: action.payload.isFromHistory,
            };
        case AssignmentsActions.SHIFT_APPROVE_GUARD_HOURS_SUCCESS:
            return {
                ...state,
                selectedShift: action.payload,
                assignment: {
                    ...state.assignment,
                    shifts: state.assignment.shifts.map(shift => {
                        if (shift.id == action.payload.id) {
                            return action.payload;
                        }
                        return shift
                    })
                }
            };
        case AssignmentsActions.LOAD_ASSIGNMENTS_STATISTICS_SUCCESS:
            return {
                ...state,
                assignmentStatistics: action.payload,
            };
        case AssignmentsActions.LOAD_REPORTS_SUCCESS:
            return {
                ...state,
                // reports: [...state.reports, ...action.payload.data],
                reports: action.payload.data,
                pagination: action.payload.pagination,
            };
        case AssignmentsActions.LOAD_REPORT_SUCCESS:
            return {
                ...state,
                selectedReport: action.payload.data,
            };
        case AssignmentsActions.LOAD_CUSTOMER_JOB_OFFERS:
            return {
                ...state,
                assignmentsLoading: true
            };
        case AssignmentsActions.LOAD_CUSTOMER_JOB_OFFERS_SUCCESS:
            return {
                ...state,
                assignments: action.payload.data,
                assignmnetMonth: action.payload.month,
                assignmentsLoading: false
            };
        case AssignmentsActions.LOAD_CUSTOMER_JOB_OFFERS_FAILED:
            return {
                ...state,
                assignmentsLoading: false
            };
        case AssignmentsActions.LOAD_CUSTOMER_JOB_DEFUALT:
            return {
                ...state,
                assignmentsLoading: true
            };
        case AssignmentsActions.LOAD_CUSTOMER_JOB_DEFUALT_SUCCESS:
            return {
                ...state,
                jobdefualt: action.payload.data,
                assignmentsLoading: false
            };
        case AssignmentsActions.LOAD_CUSTOMER_JOB_DEFUALT_FAILED:
            return {
                ...state,
                assignmentsLoading: false
            };
        case AssignmentsActions.SELECT_SHIFT_ON_OPEN_ASSIGNMENT:
            return {
                ...state,
                selectedShift: state.assignment.shifts.find(shift => {
                    return shift.id === action.payload
                })
            };
        case AssignmentsActions.CLEAR_SELECTED_SHIFT:
            return {
                ...state,
                selectedShift: null
            };
        case AssignmentsActions.RATE_GUARD_FOR_SHIFT_SUCCESS:
            return {
                ...state,
                selectedShift: {
                    ...state.selectedShift,
                    guards: {
                        ...state.selectedShift?.guards,
                        hired: state.selectedShift.guards.hired.map(guard => {
                            if (guard.id === action.payload.guardId) {
                                return {
                                    ...guard,
                                    guardShift: {
                                        ...guard.guardShift,
                                        rating: action.payload.rate
                                    }
                                };
                            }
                            return guard;
                        })
                    }
                },
                assignment: {
                    ...state.assignment,
                    shifts: state.assignment.shifts.map(shift => {
                        if (shift.id === action.payload.shiftId) {
                            return {
                                ...shift,
                                guards: {
                                    ...shift.guards,
                                    hired: shift.guards.hired.map(guard => {
                                        if (guard.id === action.payload.guardId) {
                                            return {
                                                ...guard,
                                                guardShift: {
                                                    ...guard.guardShift,
                                                    rating: action.payload.rate
                                                }
                                            };
                                        }
                                        return guard;
                                    })
                                }
                            };
                        }
                        return shift;
                    })

                }
            };
        case AssignmentsActions.LOAD_ASSIGNMENTS:
            return {
                ...state,
                assignmentsLoading: true
            };
        case AssignmentsActions.UPDATE_SHIFT_SUCCESS: {
            const updatedShift = action.payload.data;

            return {
                ...state,
                assignment: state.assignment
                    ? {
                        ...state.assignment,
                        shifts: state.assignment.shifts.map(shift =>
                            shift.id === updatedShift.id ? updatedShift : shift
                        ),
                    }
                    : null,
                selectedShift: updatedShift,
            };
        }
        case AssignmentsActions.LOAD_ASSIGNMENTS_SUCCESS:
            return {
                ...state,
                assignments: action.payload.assignments,
                pagination: action.payload.pagination,
                assignmentsLoading: false
            };
        case AssignmentsActions.LOAD_ASSIGNMENTS_FAILED:
            return {
                ...state,
                assignmentsLoading: false
            };
        case AssignmentsActions.CLEAR_ASSIGNMENTS:
            return {
                ...state,
                assignments: []
            };
        case AssignmentsActions.CLEAR_ASSIGNMENT:
            return {
                ...state,
                assignment: null
            };
        case AssignmentsActions.LOAD_ASSIGNMENT_DETAILS:
            return {
                ...state,
                loading: true
            };
        case AssignmentsActions.LOAD_ASSIGNMENT_DETAILS_SUCCESS:
            return {
                ...state,
                assignment: action.payload.assignment,
                loading: false
            };
        case AssignmentsActions.CANCEL_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                assignment: action.payload.assignment,
                loading: false
            };
        case AssignmentsActions.LOAD_ASSIGNMENT_DETAILS_FAILED:
            return {
                ...state,
                loading: false
            };
        case AssignmentsActions.ADD_ASSIGNMENT:
            return {
                ...state,
                loading: true
            };
        case AssignmentsActions.ADD_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                assignments: [action.payload.assignment, ...state.assignments],
                loading: false
            };
        case AssignmentsActions.ADD_ASSIGNMENT_FAILED:
            return {
                ...state,
                loading: false
            };
        case AssignmentsActions.ADD_ASSIGNMENT_AS_DRAFT_SUCCESS:
            return {
                ...state,
                assignments: [action.payload.assignment, ...state.assignments],
                loading: false
            };
        case AssignmentsActions.ADD_ASSIGNMENT_AS_DRAFT_FAILED:
            return {
                ...state,
                loading: false
            };
        case AssignmentsActions.CALCULATE_PRICE:
            return {
                ...state,
                loading: true
            };
        case AssignmentsActions.CALCULATE_PRICE_SUCCESS:
            return {
                ...state,
                price: action.payload.price,
                loading: false
            };
        case AssignmentsActions.CALCULATE_PRICE_FAILED:
            return {
                ...state,
                loading: false
            };
        case AssignmentsActions.LOAD_ASSIGNMENT_CATEGORIES:
            return {
                ...state,
                loading: true
            };
        case AssignmentsActions.LOAD_ASSIGNMENT_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload.categories,
                loading: false
            };
        case AssignmentsActions.LOAD_ASSIGNMENT_CATEGORIES_FAILED:
            return {
                ...state,
                loading: false
            };
        case AssignmentsActions.UPDATE_STEP:
            return {
                ...state,
                step: action.payload
            };
        case AssignmentsActions.LOAD_OBJECT_GUARDS:
            return {
                ...state,
                guardsMeta: {
                    ...state.guardsMeta,
                    page: state.guardsMeta.page + 1,
                    isLastPage: true
                },
                loading: true
            };
        case AssignmentsActions.LOAD_OBJECT_GUARDS_SUCCESS:
            return {
                ...state,
                guards: [...state.guards, ...action.payload.guards],
                guardsPagination: action.payload.pagination,
                guardsMeta: {
                    ...state.guardsMeta,
                    isLastPage: action.payload.pagination.currentPage == action.payload.pagination.lastPage
                },
                loading: false
            };
        case AssignmentsActions.LOAD_OBJECT_GUARDS_FAILED:
            return {
                ...state,
                loading: false
            };
        case AssignmentsActions.CLEAR_GUARDS:
            return {
                ...state,
                guards: [],
                guardsMeta: {
                    ...state.guardsMeta,
                    page: 0,
                    isLastPage: true
                },
                loading: false
            };
        case AssignmentsActions.LOAD_PREVIOUS_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                previousAssignments: action.payload // payload should be PreviousAssignmentResponse
            };

        case AssignmentsActions.LOAD_PREVIOUS_ASSIGNMENT_FAILED:
            return {
                ...state,
                previousAssignments: null
            };
        default:
            return state;
    }
}